(ns app.front.view.group.admin.fees.core
  (:require [app.front.ui.section :as section]
            [app.front.ui.tabs :as ui-tabs]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.fees.payment.payment-core :as payment-management]
            [app.front.view.group.admin.fees.reversal-methods.core :as reversal-methods]
            [app.front.view.group.admin.fees.schedule.schedule-core :as fee-schedule-management]
            [app.front.view.group.admin.fees.schedule.schedule-events :as fs-events]
            [app.front.view.group.admin.fees.schedule.schedule-modal :as fee-schedule-modal]
            [app.front.view.group.admin.fees.schedule.schedule-subs :as fs-subs]
            [app.front.view.group.admin.fees.settings :as fee-settings]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [schema.core :as s]))


(def tabs [:fees/active-schedules
           :fees/archived-schedules
           :fees/reversal-methods
           :fees/settings
           :fees/payment-settings])

(defn payment-settings [tr]
  [section/section
   "payment-settings"
   {:tr                   tr
    :initially-collapsed? false}
   (tr [:fees/payment-settings])
   [payment-management/view]])

(defn authority-group-view [match]
  (let [tr                        (<sub [::gas/group-tr])
        current-tab               (or (<sub [::fs-subs/fee-config-tab]) :fees/active-schedules)
        active-schedules          (<sub [::fs-subs/active-fee-schedules])
        archived-schedules        (<sub [::fs-subs/archived-fee-schedules])
        reversal-methods-enabled? (<sub [::ff/enabled? :feature-flag.id/bill-reversal-methods])
        settings-enabled?         (or (<sub [::ff/enabled? :feature-flag.id/bill-invoice-numbering])
                                      (<sub [::ff/enabled? :feature-flag.id/wizard-estimate-costs]))
        available-tabs            (cond->> tabs
                                    (not reversal-methods-enabled?) (remove #{:fees/reversal-methods})
                                    (not settings-enabled?)         (remove #{:fees/settings}))
        header-content            [ui-tabs/tabs
                                   {:selected-id current-tab
                                    :aria-label  (tr [:fees/fee-schedule-management])
                                    :on-change   #(>evt [::fs-events/fee-config-tab-changed %])
                                    :tabs        (for [tab available-tabs]
                                                   {:id    tab
                                                    :label (tr [tab])})}]]
    [acommon/admin-page-v2 {:title          (tr [:fees/fee-schedule-management])
                            :match          match
                            :header-content header-content}
     [fee-schedule-modal/copy-schedules-modal tr]
     (case current-tab
       :fees/active-schedules   [fee-schedule-management/view active-schedules]
       :fees/settings           [:div [fee-settings/view]]
       :fees/payment-settings   [:div [payment-settings tr]]
       :fees/reversal-methods   (if reversal-methods-enabled?
                                  [reversal-methods/view tr]
                                  [fee-schedule-management/view active-schedules])
       :fees/archived-schedules [fee-schedule-management/view archived-schedules
                                 :empty-placeholder :fees/no-archived-schedules])]))

(defn superdomain-group-view [match]
  (let [tr               (<sub [::gas/group-tr])
        active-schedules (<sub [::fs-subs/active-fee-schedules])]
    [acommon/admin-page-v2 {:title (tr [:fees/fee-schedule-management])
                            :match match}
     [fee-schedule-management/view active-schedules]]))

(defn view [match]
  (if (<sub [::gas/superdomain-group?])
    (superdomain-group-view match)
    (authority-group-view match)))

;;; Route
(def route
  {:name        :view/group.admin.fees
   :view        view
   :public?     false
   :own-layout? true
   :view-sub    [::fs-subs/view-data]
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::fee-schedule-management/init group-id])
                                  (>evt [::gas/fetch-authority-groups group-id])
                                  (>evt [::fee-settings/init group-id])
                                  (>evt [::reversal-methods/init group-id])))}]})
